import { AnalyticsService } from 'polly-commons';
import { Injectable } from '@angular/core';
import { POLLY_MANAGE_CUSTOM_EVENT } from '../../../polly-manage-analytics.constants';
import { MixpanelPropertiesInterface } from '../../interfaces/analytics.interface';
import { FilterParam } from '../../interfaces/elastic-query.interface';
import { getAllSelectedFilters } from '../../utilities/polly-manage.utilities';

@Injectable({
  providedIn: 'root',
})
export class PollyManageAnalyticsService {
  /** This is used for generating events by prefixing it to events */
  public lastEventCall?: string;
  private rootOpeningContext?: string;
  constructor(private readonly analyticsService: AnalyticsService) {}

  public get openingContext(): string {
    return this.rootOpeningContext ?? '';
  }

  public set openingContext(openingContext: string) {
    this.rootOpeningContext = openingContext;
  }

  /**
   * This function cleans up and returns string containing only the letters and numbers
   * @param s string to be generate name from
   */
  public generateName(s: string): string {
    return s
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .toLowerCase()
      .split(' ')
      .map((str) => str.charAt(0).toUpperCase() + str.substring(1))
      .join('');
  }

  /**
   * This function sends event to Google Tag Manager
   * @param modified Event data
   * @param addOpeningContext if true, modified will be prefixed with the Opening Context
   * @param email Email of User
   * @param properties properties of Explorer card
   * @param event Event name [Default = Custom Event]
   */
  public sendGTMEvent(
    modified: string,
    addOpeningContext: boolean = true,
    event: string = POLLY_MANAGE_CUSTOM_EVENT,
    email?: string
  ): void {
    if (addOpeningContext) modified = this.openingContext + '_' + modified;
    this.analyticsService.sendGTMEvent({ event, modified, eventContext: modified, email });
    if (!modified.toLowerCase().includes('heartbeat')) this.lastEventCall = modified;
  }

  public sendMixpanelEvent(
    modified: string,
    addOpeningContext: boolean = true,
    mixpanelProperties?: MixpanelPropertiesInterface,
    selectedFilters?: FilterParam,
    email?: string,
    event: string = POLLY_MANAGE_CUSTOM_EVENT
    ): void {
      let properties = mixpanelProperties;
      if (selectedFilters){
        properties = {...mixpanelProperties, ...getAllSelectedFilters(selectedFilters)};
      }
      if (addOpeningContext) modified = this.openingContext + '_' + modified;
      this.analyticsService.sendMixpanelEvent({ event, modified, eventContext: modified, email, properties });
    }

  /**
   * This function handle the No Event match case
   * @param event Event Name
   */
  public noEventMatched(event: string): void {
    console.error('No GTM events match for ', event);
  }
}
